import React, { useEffect, useState } from "react";
import "grapesjs/dist/css/grapes.min.css";
import grapesjs from "grapesjs";
import pluginWebPage from "grapesjs-preset-webpage";
import pluginForms from "grapesjs-plugin-forms";
import pluginCountdown from "grapesjs-component-countdown";
import pluginExport from "grapesjs-plugin-export";
import pluginTabs from "grapesjs-tabs";
import pluginCustomCode from "grapesjs-custom-code";
import pluginTouch from "grapesjs-touch";
import pluginPostCSS from "grapesjs-parser-postcss";
import pluginTooltip from "grapesjs-tooltip";
import pluginImageEditor from "grapesjs-tui-image-editor";
import pluginTyped from "grapesjs-typed";
import pluginStyleBg from "grapesjs-style-bg";
import pluginBlocksBasic from "grapesjs-blocks-basic";
import { Button, Flex, Input, message, Select } from "antd";

const Help = () => {
  const [editor, setEditor] = useState(null);
  const [pageId, setPageId] = useState(null);
  const [pages, setPages] = useState([]);
  const [pageTitle, setPageTitle] = useState('Enter Page Title here');
  const token = localStorage.getItem("adminLoginToken");

  useEffect(() => {
    const editorInstance = grapesjs.init({
      container: "#gjs",
      fromElement: false,
      height: "calc(100vh - 186px)",
      width: "100%",
      plugins: [
        pluginBlocksBasic,
        pluginForms,
        pluginCountdown,
        pluginExport,
        pluginTabs,
        pluginCustomCode,
        pluginTouch,
        pluginPostCSS,
        pluginTooltip,
        pluginImageEditor,
        pluginTyped,
        pluginStyleBg,
        pluginWebPage,
      ],
      storageManager: false,
      canvas: {
        styles: [
          "https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css",
          `.gjs-row {
              display: flex;
          }
          .gjs-cell {
              padding: 10px;
              box-sizing: border-box;
          }`,
        ],
      },
    });

    setEditor(editorInstance);
    fetchAllPages(); // Fetch all pages on component mount

    return () => {
      editorInstance.destroy();
    };
  }, []);

  const fetchAllPages = async () => {
    try {
      const response = await fetch(`${window.API_BASE_URL}/users/pages`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        const { pages } = await response.json();
        setPages(pages);
      } else {
        message.error("Failed to load pages!");
      }
    } catch (error) {
      console.error("Error fetching pages:", error);
    }
  };

  const fetchPageContent = async (id) => {
    if (!editor) return;

    try {
      const response = await fetch(`${window.API_BASE_URL}/users/page/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        const { page } = await response.json();
        setPageTitle(page.title);
        editor.setComponents(page.html);
        editor.setStyle(page.css);
      } else {
        message.warn("Page content not found. Starting with a blank template.");
        editor.setComponents(""); // Blank canvas
        editor.setStyle("");
      }
    } catch (error) {
      console.error("Error loading content:", error);
    }
  };

  const handleSaveContent = async () => {
    if (editor) {
      const html = editor.getHtml();
      const css = editor.getCss();
      const title = pageTitle;

      try {
        const response = await fetch(`${window.API_BASE_URL}/users/page`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id: pageId, html, css, title }),
        });

        if (response.ok) {
          const result = await response.json();
          message.success(result.message);
        } else {
          message.error("Error saving page!");
        }
      } catch (error) {
        console.error("Error saving content:", error);
      }
    }
  };

  const handlePageChange = (value) => {
    setPageId(value);
    if (value) fetchPageContent(value); 
    else {
      editor.setComponents("");
      editor.setStyle("");
    }
  };

  return (
    <div>
      <Flex justify="space-between" align="center" style={{ height: 50 }}>

        <Select
          placeholder="Select Page"
          onChange={handlePageChange}
          style={{ width: 200 }}
        >
          <Select.Option value={null}>Blank Page</Select.Option>
          {pages.map((page) => (
            <Select.Option key={page.id} value={page.id}>
              {page.title}
            </Select.Option>
          ))}
        </Select>
        <Flex justify="flex-end" align="center" gap={16}>
          <Input value={pageTitle} onChange={(e) => setPageTitle(e.target.value)} style={{width:200}} />
          <Button type="primary" onClick={handleSaveContent}>
            {pageId ? 'Update' : 'Save'}
          </Button>
        </Flex>
      </Flex>
      <div id="gjs"></div>
    </div>
  );
};

export default Help;